export default "__VITE_ASSET__n4aLUU2Q__"